import { useContext } from "react";
import { useSelector } from "react-redux";
import { Id, Identifiable, Project } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  project: Identifiable<Project>;
  retrieveProject(projectId: Boundaries["retrieveProject"]["request"]): void;
}

function useProjectRetrieval(projectId: Id): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isProjectRetrievalRequestPending(projectId),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isProjectRetrievalRequestSuccess(projectId),
    ),
    isRequestFailure: useSelector(() =>
      selector.isProjectRetrievalRequestFailure(projectId),
    ),
    project: useSelector(() => selector.getProject(projectId)),
    retrieveProject: core.retrieveProject,
  };
}

export { useProjectRetrieval };
